import { render, staticRenderFns } from "./URLHref.vue?vue&type=template&id=40cf7018&scoped=true"
import script from "./URLHref.vue?vue&type=script&lang=js"
export * from "./URLHref.vue?vue&type=script&lang=js"
import style0 from "./URLHref.vue?vue&type=style&index=0&id=40cf7018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf7018",
  null
  
)

export default component.exports